var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCondition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m106 8.789-81.211 82.211h81.211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331 135.702v-135.702h-195v121h-120v300h315v-44.702c-44.258-22.181-75-67.509-75-120.298s30.742-98.117 75-120.298zm-105 225.298h-150v-30h150zm0-60h-150v-30h150zm0-60h-150v-30h150zm0-60h-150v-30h150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 151c-57.99 0-105 47.01-105 105 0 52.852 39.179 96.152 90 103.488v152.512h30v-152.512c50.821-7.335 90-50.636 90-103.488 0-57.99-47.01-105-105-105zm-15 156.211-51.211-51.211 21.211-21.211 30 30 60-60 21.211 21.211z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondition);
export default __webpack_public_path__ + "static/media/condition.3a085b8e.svg";
export { ForwardRef as ReactComponent };